import React, { useState } from 'react';
import Header from './Header';
import DrawerMenu from './DrawerMenu';
import Footer from './Footer';
import { Outlet, useLocation } from 'react-router-dom';
import { useCmsData } from '../../hooks/useCmsData';
import { IPageLayout } from '../../cms/interfaces/IPageLayout';
import { Box, BoxProps, Typography, styled } from '@mui/material';
import Popup from './Popup';
import CookieConsent from './CookieConsent';
import { useTranslation } from 'react-i18next';
import LoginWithGoogle from './LoginWithGoogle';
import GoogleAnalyticsProvider from '../../context/GoogleAnalyticsProvider';

interface Props {

}

const StyledBox = styled(Box)<BoxProps>(({theme}) => ({
    background: theme?.palette?.background?.default
}));

const PageLayout : React.FC<Props> = () => {
    const location = useLocation();
    const {t} = useTranslation("common");
    const [loginOpen, setLoginOpen] = useState(false);
    let lang = 'de' as ("de" | "en");
    if(location?.pathname === undefined || location?.pathname === "/" || location?.pathname === "/de" || location?.pathname === "/de/") {
        window.location.pathname = '/de/neuigkeiten';
    }
    else if(location?.pathname === "/en" || location?.pathname === "/en/") {
        window.location.pathname = '/en/news';
    }

    if(location?.pathname?.startsWith("/en")) {
      lang = 'en';
    }

    const [menuOpen, setMenuOpen] = useState(false);
    const [data] = useCmsData<Array<IPageLayout>>({docType: "pagelayout", language: lang, additonalQueryString: ` && theme == 'stefanhasenberg.de'`, fields: `
    ...,
    footerref{
      ...,
      content{
        ...,
        rows[]{
          ...,
          cells[]{
            ...,
            list{
              ...,
              listitems[]{
                ...,
                pageRef->{relativeUrl}
              }
            }
          }
        }
      }
    },
    navigationmenu{
      ...,
      listitems[]{
        ...,
        pageRef->{relativeUrl}
      }
    }`});

    const pageLayout = data?.[0];

    return <GoogleAnalyticsProvider measurementId='G-D5BCFYXZJP'>
        <StyledBox>
            <header>
                <Header toggleMenu={() => setMenuOpen(!menuOpen)} headerSpecs={pageLayout?.headerref} toogleLogin={() => setLoginOpen(!loginOpen)} />
            </header>
            <DrawerMenu open={menuOpen} toggleMenu={() => setMenuOpen(!menuOpen)} navigationList={pageLayout?.navigationmenu} />
            <Popup key={`login_${loginOpen}`} open={loginOpen}>
              <Typography variant='h2' sx={{marginBottom: "1em"}}>{t("common.login.title")}</Typography>
              <LoginWithGoogle />
            </Popup>
            <main>
                <Outlet />
                {pageLayout?.cookieinfo && <CookieConsent content={pageLayout?.cookieinfo} />}
            </main>
      </StyledBox>
      <footer>
        <Footer {...pageLayout?.footerref} />
      </footer>
    </GoogleAnalyticsProvider>
}

export default PageLayout;